import * as React from 'react'
import Progress from 'components/ui/progress-bar'

export const TracksMeter = ({
  current,
  max,
}: {
  current: number
  max?: number | null
}): React.ReactNode => {
  // an absent, zero, or infinite max all mean "unlimited", as does zero usage:
  // both render a full gray bar rather than a meaningful ratio
  const isUnlimited = max == null || max === 0
  const progressValue = isUnlimited ? 0 : (current / max) * 100

  if (isUnlimited || !isFinite(progressValue) || progressValue === 0) {
    return <Progress value={100} color="gray" />
  }

  if (progressValue >= 100) {
    return <Progress value={100} color="red" />
  }

  return <Progress value={progressValue} />
}
